<template>
  <div class="from-to-form">
    <app-spoiler title="Wystawca" disabled>
      <button v-if="direction == 0" type="button" @click="fillWithOrg(1)" class="btn btn--gradient btn--small" style="margin-bottom: 10px">Zamień sprzedawcę z nabywcą</button>
      <app-input type="text" name="from_name" placeholder="Nazwa" required v-model="from.name" list="contractors-list" ></app-input>
      <app-input type="text" name="from_vat" placeholder="NIP" v-model="from.vat" list="vats-list" ></app-input>
      <app-input type="text" name="from_address" placeholder="Adres" required v-model="from.address"></app-input>
      <div class="row">
        <app-input type="text" name="from_post_code" placeholder="Kod pocztowy" required v-model="from.post_code"></app-input>
        <app-input type="text" name="from_city" placeholder="Miasto" required v-model="from.city"></app-input>
      </div>
      <app-input type="text" name="from_email" placeholder="Email" v-model="from.email"></app-input>
      <div class="row">
        <app-input type="text" name="from_phone" placeholder="Telefon" v-model="from.phone"></app-input>
        <app-input type="text" name="from_website" placeholder="Strona internetowa" v-model="from.website"></app-input>
      </div>
    </app-spoiler>

    <app-spoiler title="Odbiorca">
      <button v-if="direction == 1" type="button" @click="fillWithOrg(0)" class="btn btn--gradient btn--small" style="margin-bottom: 10px">Zamień sprzedawcę z nabywcą</button>
      <app-input type="text" name="to_name" placeholder="Nazwa" required v-model="to.name" list="contractors-list" ></app-input>
      <app-input type="text" name="to_vat" placeholder="NIP" v-model="to.vat" list="vats-list" ></app-input>
      <app-input type="text" name="to_address" placeholder="Adres" required v-model="to.address"></app-input>
      <div class="row">
        <app-input type="text" name="to_post_code" placeholder="Kod pocztowy" required v-model="to.post_code"></app-input>
        <app-input type="text" name="to_city" placeholder="Miasto" required v-model="to.city"></app-input>
      </div>
      <app-input type="text" name="to_email" placeholder="Email" v-model="to.email"></app-input>
      <div class="row">
        <app-input type="text" name="to_phone" placeholder="Telefon" v-model="to.phone"></app-input>
        <app-input type="text" name="to_website" placeholder="Strona internetowa" v-model="to.website"></app-input>
      </div>
    </app-spoiler>

    <datalist id="contractors-list">
      <option v-for="contractor in contractors" :key="contractor.id" :value="contractor.name">{{contractor.name}}</option>
    </datalist>
    <datalist id="vats-list">
      <option v-for="contractor in contractors" :key="contractor.id" :value="contractor.vat">{{contractor.name}}</option>
    </datalist>
  </div>
</template>

<script>

import Input from "@/components/Input.vue"
import Spoiler from '@/components/Spoiler.vue'
export default {
  name: 'from-to-form',
  components: {
    AppInput: Input,
    AppSpoiler: Spoiler
  },
  data: () => ({
    direction: 1,
    from: {
      name: '',
      vat: '',
      address: '',
      city: '',
      post_code: '',
      phone: '',
      email: '',
      website: ''
    },
    to: {
      name: '',
      vat: '',
      address: '',
      city: '',
      post_code: '',
      phone: '',
      email: '',
      website: ''
    }
  }),
  props: {
    contractors: Array,
    value: Object,
    company: Object,
  },
  methods: {
    fillWithOrg(direction, company = this.company) {
      const copy = JSON.parse(JSON.stringify(direction === 0 ? this.to : this.from))

      this.to = {
        name: '',
        vat: '',
        address: '',
        city: '',
        post_code: '',
        phone: '',
        email: '',
        website: ''
      }
      this.from = {
        name: '',
        vat: '',
        address: '',
        city: '',
        post_code: '',
        phone: '',
        email: '',
        website: ''
      }

      this.direction = direction

      if(direction === 0) {

        this.from = copy

        if(typeof company == 'object')
          for(let key in company)
            this.to[key] = company[key]

      } else {

        this.to = copy

        if(typeof company == 'object')
          for(let key in company)
            this.from[key] = company[key]

      }
    },
    fillWithContractor(options) {
      const contractor = options.name ?
        this.contractors.find((company) => company.name == options.name) :
        this.contractors.find((company) => company.vat == options.vat)

      if(contractor) {
        const data = options.direction == 0 ? this.to : this.from

        for(let key in data) {
          data[key] = contractor[key] || ''
        }
      }
    },
    bumpState() {
      this.$emit('input', {
        from: this.from,
        to: this.to,
        direction: this.direction
      })
    }
  },
  watch: {
    value() {
      this.from = this.value.from
      this.to = this.value.to
      this.direction = this.value.direction
    },
    from() {this.bumpState()},
    to() {this.bumpState()},
    direction() {this.bumpState()},
    'to.name'() {
      this.fillWithContractor({name: this.to.name, direction: 0})
    },
    'from.name'() {
      this.fillWithContractor({name: this.from.name, direction: 1})
    },
    'to.vat'() {
      this.fillWithContractor({vat: this.to.vat, direction: 0})
    },
    'from.vat'() {
      this.fillWithContractor({vat: this.from.vat, direction: 1})
    }
  }
}
</script>

<style lang="scss">
  .from-to-form {

  }
</style>
